<div class="loader-container" *ngIf="isLoading">
  <div class="loader"></div>
</div>
<div class="add-app-button" *ngIf="topicId"></div>
<div
  class="app-btns-container"
  *ngIf="apps.length == 0 && topicId && !isLoading && user.roles !== 'student'"
>
  <div class="row app-btns-row">
    <div class="col">
      <button
        class="app-button"
        data-toggle="modal"
        data-target="#app-model"
        (click)="addApp('image')"
      >
        <span class="mr-2"><i class="fas fa-images fa-xl"></i></span>
        <span>Image app</span>
      </button>
    </div>
    <div class="col">
      <button
        class="app-button"
        data-toggle="modal"
        data-target="#app-model"
        (click)="addApp('video')"
      >
        <span class="mr-2"><i class="fas fa-file-video fa-xl"></i></span>
        <span>Video app</span>
      </button>
    </div>
    <div class="col">
      <button
        class="app-button"
        data-toggle="modal"
        data-target="#app-model"
        (click)="addApp('text')"
      >
        <span class="mr-2"><i class="fas fa-file-signature fa-xl"></i></span>
        <span>Text app</span>
      </button>
    </div>
  </div>
</div>
<div
  class="app-btns-container"
  *ngIf="apps.length == 0 && topicId && !isLoading && user.roles == 'student'"
>
  Data not found!
</div>
<div
  class="search-container"
  *ngIf="topicId && !isReadMode && !isLoading && user.roles !== 'student'"
>
  <div class="search-type-select">
    <ng-select
      style="z-index: 1"
      [items]="['All', 'Video', 'Image', 'Text']"
      [searchable]="false"
      [clearable]="false"
      [(ngModel)]="selectedItem"
    ></ng-select>
  </div>
  <input
    type="text"
    placeholder="Search Apps"
    [(ngModel)]="searchValue"
    (keydown.enter)="searchApp(searchValue)"
    class="search-input"
  />
  <button class="search-button" (click)="searchApp(searchValue)">
    <img src="assets/search_icon.svg" />
  </button>
</div>


<div class="search-container" *ngIf="topicId && isReadMode && !isLoading">
  <!-- <input type="text" placeholder="Search Apps" [(ngModel)]="searchValue" class="search-input"> -->
  <!-- <input type="text" class="form-control" placeholder="Search" [formControl]="searchForm.get('searchInput')"
  [ngbTypeahead]="searchItems" [resultFormatter]="formatItem" [(ngModel)]="selected"> -->
  <div class="form-group">
    <input
      type="text"
      class="form-control"
      placeholder="Search"
      [(ngModel)]="searchTerm"
    />

    <div class="list-group mt-2" *ngIf="filteredItems$.length > 0">
      <a
        class="list-group-item list-group-item-action"
        *ngFor="let item of filteredItems$"
        (click)="selectItem(item?.name)"
      >
        {{ item.name }}
      </a>
    </div>
  </div>

  <button class="search-button"><img src="assets/search_icon.svg" /></button>
</div>

<div
  class="app-view-container container"
  [class.margin-top-220px]="isAddFormShow"
  *ngIf="(!isLoading && user.roles === 'admin') || empType.includes('Teacher')"
>
  <div
    class="app-btns-container2"
    *ngIf="topicId && !isLoading && isAddFormShow"
  >
    <div class="row app-btns-row2">
      <div class="col">
        <button
          class="app-button"
          data-toggle="modal"
          data-target="#app-model"
          (click)="addApp2('image', topicId)"
        >
          <span class="mr-2"><i class="fas fa-images fa-xl"></i></span>
          <span>Image app</span>
        </button>
      </div>
      <div class="col">
        <button
          class="app-button"
          data-toggle="modal"
          data-target="#app-model"
          (click)="addApp2('video', topicId)"
        >
          <span class="mr-2"><i class="fas fa-file-video fa-xl"></i></span>
          <span>Video app</span>
        </button>
      </div>
      <div class="col">
        <button
          class="app-button"
          data-toggle="modal"
          data-target="#app-model"
          (click)="addApp2('text', topicId)"
        >
          <span class="mr-2"><i class="fas fa-file-signature fa-xl"></i></span>
          <span>Text app</span>
        </button>
      </div>
    </div>
  </div>
  <!----- Admin & Teacher --------------------------->
  <div *ngIf="!isAddFormShow || isAddFormShow">
    <div *ngIf="user.roles !== 'student'">
      <div class="d-flex" style="overflow: auto">
        <!-- <div  *ngIf="isAddFormShow || !isAddFormShow" class="d-flex app-paging" cdkDropList (cdkDropListDropped)="isDragDropEnabled?onDragDropContent($event,'apps'):false">
          <p cdkDrag *ngFor="let app of apps; let i = index"
          [cdkDragData]="app"
          class="cursor-pointer content-index"
          [ngClass]="{'active': selectedAppContent === i}"
          (click)="showContent(i)">
          {{i + 1}}
       </p>
        </div> -->
        <div
          cdkDropList
          (cdkDropListDropped)="
            isDragDropEnabled ? onDragDropContent($event, 'apps') : false
          "
          class="app-list-horizontal"
          cdkDropListOrientation="horizontal"
        >
          <div
            *ngFor="let app of apps; let i = index"
            cdkDrag
            class="cursor-pointer content-index-horizontal"
            [ngClass]="{ active: selectedAppContent === i }"
            (click)="showContent(i)"
          >
            <div class="index-div">
              {{ i + 1 }}
            </div>
          </div>
        </div>

        <p
          style="margin: 10px"
          *ngIf="apps.length > 0 && !isAddFormShow"
          (click)="toggleView()"
          class="cursor-pointer content-index"
          (click)="showContent(i)"
        >
          +
        </p>
      </div>
      <div *ngFor="let app of apps; let i = index">
        <div>
          <div *ngIf="selectedAppContent == i">
            <i
              class="ft-share text-primary cursor-pointer mx-1"
              placement="top"
              ngbTooltip="share"
              mat-button
              [matMenuTriggerFor]="menu"
            ></i>
            <i
              class="ft-copy text-primary cursor-pointer mx-1"
              placement="top"
              ngbTooltip="copy"
              (click)="copyApp(app?._id)"
            ></i>
          </div>
          <mat-menu #menu="matMenu" id="menu">
            <div class="share-buttons">
              <a
                [href]="getWhatsappShareUrl(app?._id)"
                target="_blank"
                class="share-button whatsapp"
              >
                <img
                  src="assets/whatsapp-icon-invite.svg"
                  alt="whatsapp"
                  width="30"
                />
              </a>
              <a
                [href]="getFacebookShareUrl(app?._id)"
                target="_blank"
                class="share-button facebook"
              >
                <img
                  src="assets/facebook-icon-invite.svg"
                  alt="facebook"
                  width="30"
                />
              </a>
              <a [href]="getEmailShareUrl(app?._id)" class="share-button email">
                <img
                  src="assets/email-icon-invite.svg"
                  alt="email"
                  width="30"
                />
              </a>
            </div>
          </mat-menu>
        </div>
        <div class="app-section" *ngIf="selectedAppContent === i">
          <div class="col d-flex align-items-center">
            <div class="app-title">
              <h4 class="app-title-h4">
                {{ app?.title }}
              </h4>
            </div>
            <div>
              <p placement="top" ngbTooltip="Updated Date">
                {{ app?.updated_at | date : "mediumDate" }}
              </p>
            </div>
            <div class="app-action">
              <i
                class="ft-file-text text-primary cursor-pointer mx-1"
                placement="top"
                ngbTooltip="description"
                (click)="
                  openModalForUpdateContent(
                    myModalContentUpdate,
                    app,
                    app?._id,
                    'Description'
                  )
                "
              ></i>
              <i
                class="ft-tag text-primary cursor-pointer mx-1"
                placement="top"
                ngbTooltip="app tag"
                (click)="
                  openModalForUpdateContent(
                    myModalContentUpdate,
                    app,
                    app?._id,
                    'App Tag'
                  )
                "
              ></i>
              <i
                class="ft-settings text-primary cursor-pointer mx-1"
                placement="top"
                ngbTooltip="resources"
                (click)="
                  openModalForUpdateContent(
                    myModalContentUpdate,
                    app,
                    app?._id,
                    'Resources'
                  )
                "
              ></i>
              <i
                class="icon-docs text-primary cursor-pointer mx-1"
                placement="top"
                ngbTooltip="content script"
                (click)="
                  openModalForUpdateContent(
                    myModalContentUpdate,
                    app,
                    app?._id,
                    'Content Script'
                  )
                "
              ></i>
              <i
                class="icon-note text-primary cursor-pointer mx-1"
                placement="top"
                ngbTooltip="teacher notes"
                (click)="
                  openModalForUpdateContent(
                    myModalContentUpdate,
                    app,
                    app?._id,
                    'Teacher Notes'
                  )
                "
              ></i>
            </div>

            <div class="col d-flex justify-content-end my-2 submit-btn">
              <button
                *ngIf="
                  isSubmitted !== true &&
                  user.roles === 'student' &&
                  app?.app_tag[0]?.displayname === 'Assignment'
                "
                class="btn btn-outline-primary"
                (click)="
                  openModalForAssignment(
                    myModalContent,
                    user.id,
                    app?._id,
                    courseId,
                    topicId
                  )
                "
              >
                Submit
              </button>
              <p class="badge bg-light-success" *ngIf="isSubmitted === true">
                Submitted
              </p>
            </div>
          </div>
          <div *ngIf="app?.type === 'image'">
            <!-- Display image content -->
            <img width="100%" [src]="s3MediaUrl + app?.content" alt="Image" />
          </div>
          <div *ngIf="app?.type === 'video' && !app.isurl_link">
            <!-- Display video content -->
            <video
              width="100%"
              [src]="s3MediaUrl + app?.content"
              controls
            ></video>
          </div>
          <div *ngIf="app?.type === 'video' && app.isurl_link">
            <!-- Display video content -->
            <div [innerHTML]="app.url_link | safeHtml"></div>
            <div *ngIf="app.aws_s3_file_url">
              <video width="100%" [src]="app.aws_s3_file_url" controls></video>
            </div>
            <!-- {{formatHtmlapp?.url_link }} -->
          </div>
          <div *ngIf="app?.type === 'text'">
            <!-- Display markdown text content -->
            <div [innerHTML]="app?.content | safeHtml"></div>
          </div>
          <div
            [hidden]="isReadMode"
            *ngIf="user.roles === 'admin' || empType.includes('Teacher')"
          >
            <i
              [ngClass]="
                isConnected(app?._id) ? 'fa fa-x cursor' : 'fa fa-link cursor'
              "
              title="Disconnect app"
              (click)="connectDisconnect(app?._id)"
            ></i>
            <i
              class="fa fa-edit cursor ml-2"
              data-toggle="modal"
              data-target="#app-model"
              (click)="editApp(app)"
            ></i>
          </div>
          <!-- <div class="top-left-search" *ngIf="app.changes">
            <span><strong>Changes detected :</strong> &nbsp;&nbsp;</span>
            <p *ngFor="let item of app.changes[0].change; last as last">
              <span class="text-primary" placement="top" [ngbTooltip]="'app update date ' + (app.changes[0]?.date| date:'mediumDate')"> <strong>{{item}}</strong> </span>
              <span *ngIf="!last">,</span> 
            </p>

          </div> -->

          <div class="row p-2" *ngIf="user.roles !== 'student'">
            <div
              class="btn btn-outline-primary ml-2"
              *ngFor="let resource of app.resources"
            >
              <a [href]="s3MediaUrl + resource.documents" target="_blank">{{
                resource.content
              }}</a>
              <i
                class="fa fa-x cursor danger font-large float-right"
                (click)="resourceDelete(app?._id, resource._id)"
              ></i>
            </div>
            <!-- <div class="col-xl-3 col-lg-6 col-12" *ngFor="let resource of app.resources">
                <div class="card">
                  <div class="card-content">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body text-left">
                          <h3 class="mb-1 danger">{{resource}}</h3>
                          <span></span>
                        </div>
                        <div class="media-right align-self-center">
                          <i class="fa fa-x cursor danger font-large-1 float-right"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-------- Student View ---------------------->
  <div *ngIf="user.roles === 'student'">
    <div *ngFor="let app of apps">
      <div class="app-section student">
        <div class="col d-flex align-items-center">
          <div class="container">
            <div class="d-flex justify-content-between">
              <div class="app-title">
                <h4 class="app-title-h4">
                  {{ app?.title }}
                </h4>
              </div>
            </div>
          </div>

          <div class="col d-flex justify-content-end my-2 submit-btn">
            <button
              *ngIf="
                isSubmitted !== true &&
                user.roles === 'student' &&
                app?.app_tag[0]?.displayname === 'Assignment'
              "
              class="btn btn-outline-primary"
              (click)="
                openModalForAssignment(
                  myModalContent,
                  user.id,
                  app?._id,
                  courseId,
                  topicId
                )
              "
            >
              Submit
            </button>
            <p class="badge bg-light-success" *ngIf="isSubmitted === true">
              Submitted
            </p>
          </div>
        </div>
        <div *ngIf="app?.type === 'image'">
          <!-- Display image content -->
          <img width="100%" [src]="s3MediaUrl + app?.content" alt="Image" />
        </div>
        <div *ngIf="app?.type === 'video' && !app.isurl_link">
          <!-- Display video content -->
          <video
            width="100%"
            [src]="s3MediaUrl + app?.content"
            controls
          ></video>
        </div>
        <div *ngIf="app?.type === 'video' && app.isurl_link">
          <!-- Display video content -->
          <div [innerHTML]="this.sanitizedUrl"></div>
          <div *ngIf="app.aws_s3_file_url">
            <video width="100%" [src]="app.aws_s3_file_url" controls></video>
          </div>
          <!-- {{formatHtmlapp?.url_link }} -->
        </div>
        <div *ngIf="app?.type === 'text'">
          <!-- Display markdown text content -->
          <div [innerHTML]="app?.content"></div>
        </div>
        <div
          [hidden]="isReadMode"
          *ngIf="user.roles === 'admin' || empType.includes('Teacher')"
        >
          <i
            [ngClass]="
              isConnected(app?._id) ? 'fa fa-x cursor' : 'fa fa-link cursor'
            "
            title="Disconnect app"
            (click)="connectDisconnect(app?._id)"
          ></i>
          <i
            class="fa fa-edit cursor ml-2"
            data-toggle="modal"
            data-target="#app-model"
            (click)="editApp(app)"
          ></i>
        </div>

        <div class="row p-2" *ngIf="user.roles !== 'student'">
          <div
            class="btn btn-outline-primary ml-2"
            *ngFor="let resource of app.resources"
          >
            <a [href]="s3MediaUrl + resource.documents" target="_blank">{{
              resource.content
            }}</a>
            <i
              class="fa fa-x cursor danger font-large float-right"
              (click)="resourceDelete(app?._id, resource._id)"
            ></i>
          </div>
          <!-- <div class="col-xl-3 col-lg-6 col-12" *ngFor="let resource of app.resources">
              <div class="card">
                <div class="card-content">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body text-left">
                        <h3 class="mb-1 danger">{{resource}}</h3>
                        <span></span>
                      </div>
                      <div class="media-right align-self-center">
                        <i class="fa fa-x cursor danger font-large-1 float-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="video-container">
  <video width="100%" height="100%" controls>
    <source src="myvideo.mp4" type="video/mp4">
    Your browser does not support the video tag.
  </video>
  <div class="video-controls">
    <i class="icon-volume-up"></i>
  </div>
</div> -->
<app-lms-content-editor
  #modalRef
  [appType]="appType"
  (closeModal)="closeModel()"
  [selectedApp]="selectedApp"
  [courseId]="courseId"
  [topicId]="topicId"
  [recentApi]="recentApi"
  (apiStatus)="onApiStatusUpdate($event)"
></app-lms-content-editor>

<!------------- Assignment Popup --------------------------------------->
<div>
  <ng-template #myModalContent>
    <div class="modal-header">
      <h4 class="modal-title">Assignment</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modalService.dismissAll()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Description</label>
        <textarea
          class="form-control"
          [(ngModel)]="assignment_model.notes"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Enter description"
          name="notes"
          id="notes"
          cols="30"
          rows="2"
        ></textarea>
      </div>
      <div class="form-group">
        <label>Teacher Notes</label>
        <textarea
          class="form-control"
          [(ngModel)]="assignment_model.admin_notes"
          [ngModelOptions]="{ standalone: true }"
          name="admin_notes"
          id="admin_notes"
          cols="30"
          rows="2"
          placeholder="Enter teacher notes"
        ></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="modalService.dismissAll()"
      >
        Close
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="assignmentSubmit()"
      >
        Save changes
      </button>
    </div>
  </ng-template>
</div>

<!----- Update Popup --------------->

<div>
  <ng-template #myModalContentUpdate>
    <div class="modal-header">
      <h4 class="modal-title">{{ modalFor }} Update</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modalService.dismissAll()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group" *ngIf="this.lms_model.description">
        <div class="card-header">
          <h5 class="card-title">Description:</h5>
          <textarea
            name="Content Scripts"
            class="form-control"
            id="textarea-input"
            [(ngModel)]="lms_model.description"
            cols="30"
            rows="2"
          ></textarea>
        </div>
      </div>
      <div class="form-group" *ngIf="this.lms_model.content_scripts">
        <div class="card-header">
          <h5 class="card-title">Content Scripts:</h5>
          <textarea
            name="Content Scripts"
            class="form-control"
            id="textarea-input"
            [(ngModel)]="lms_model.content_scripts"
            cols="30"
            rows="2"
          ></textarea>
        </div>
      </div>
      <div class="form-group" *ngIf="this.lms_model.teachers_notes">
        <div class="card-header">
          <h5 class="card-title">Teachers Notes:</h5>
          <textarea
            name="Teachers Notes"
            class="form-control"
            id="textarea-input"
            [(ngModel)]="lms_model.teachers_notes"
            cols="30"
            rows="2"
          ></textarea>
        </div>
      </div>
      <div class="card-header" *ngIf="selected_resources">
        <h5 class="card-title">Resources:</h5>
        <ng-select
          [items]="resources_list"
          bindLabel="content"
          bindValue="id"
          [multiple]="true"
          [closeOnSelect]="false"
          placeholder="Select Resource"
          [(ngModel)]="selected_resources"
          [ngModelOptions]="{ standalone: true }"
          (change)="getResourceId($event)"
        >
        </ng-select>
      </div>
      <div class="card-header" *ngIf="selected_app_tag">
        <h5 class="card-title">App Tag:</h5>
        <ng-select
          [items]="app_tags_list"
          bindLabel="displayname"
          bindValue="_id"
          [closeOnSelect]="false"
          placeholder="Select App Tag"
          [(ngModel)]="selected_app_tag"
          [ngModelOptions]="{ standalone: true }"
          (change)="getAppTagId($event)"
        >
        </ng-select>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="modalService.dismissAll()"
      >
        Close
      </button>
      <button type="button" class="btn btn-primary" (click)="updateContent()">
        Save
      </button>
    </div>
  </ng-template>
</div>
